// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Alert, {AlertProps} from '@material-ui/lab/Alert';
import {Collapse} from '@material-ui/core';
// import {colors} from '../../assets/styles/colors';

type Props = AlertProps & {
  open?: boolean,
};

const useStyles = severity =>
  makeStyles(theme => ({
    collapse: {
      width: '100%',
    },
    default: {
      // boxShadow:
      //   '0px 0px 1px rgba(233, 42, 102, 0.04), 0px 0.5px 2px rgba(159, 0, 50, 0.37)',
      color: severity ? theme.palette[severity].main : undefined,
      borderRadius: '12px',
    },
  }));

export default function CustomAlert(props: Props) {
  const {className, severity, children, open, ...otherProps} = props;

  const classes = useStyles(severity)();

  /*const { } = useSelector(state => ());*/

  return (
    <Collapse in={open} className={classes.collapse}>
      <Alert
        className={`${classes.default} ${className ? className : ''}`}
        severity={severity}
        {...(otherProps: any)}
      >
        {children}
      </Alert>
    </Collapse>
  );
}

CustomAlert.propTypes = {...Alert.propTypes, open: PropTypes.bool};
